import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'antd';
import { useCitiesData } from '../../services/queries/cities';
import DropdownSelect from '../../../../components/dropdownSelect';
import { selectors, actionCreators, sliceKeys } from '../../model';
import FetchDataWrapper from '../../../../components/FetchDataWrapper';

const { selectCurrent: selectCity } = selectors[sliceKeys.cities];
const { currentChanged: cityChanged } = actionCreators[sliceKeys.cities];

const emptyArr = Object.freeze([]);
const { dataTypes } = useCitiesData;

const SelectCity = ({ children }) => {
  const { data, isFetching, refetch } = useCitiesData({
    dataType: dataTypes.options,
  });

  const value = useSelector(selectCity);

  const dispatch = useDispatch();

  const onChange = useCallback(
    (city) =>
      dispatch(
        cityChanged(city, ({ onOk, name }) =>
          Modal.confirm(
            createConfirmData({ currentCity: name, newCity: city?.name, onOk })
          )
        )
      ),
    [dispatch]
  );

  const isOneCity = Array.isArray(data) && data.length === 1;

  useEffect(() => {
    if (isOneCity && !value) {
      onChange(data[0].value);
    }
  }, [isOneCity, data, onChange, value]);

  return (
    <FetchDataWrapper
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg="Не удалось получить список городов"
    >
      <div className="colContentWrap">
        {!isOneCity && (
          <DropdownSelect
            options={!data || data === 'Error' ? emptyArr : data}
            value={value}
            onChange={onChange}
            label="Город"
          />
        )}
        {children}
      </div>
    </FetchDataWrapper>
  );
};

export default SelectCity;

function createConfirmData({ currentCity, newCity, onOk }) {
  return {
    title: `В приемке участвуют дома из города ${currentCity}`,
    content: createContent(newCity),
    onCancel: () => {},
    onOk,
  };
}

function createContent(city) {
  if (city) {
    return `В приемке не могут участвовать дома из разных городов. При выборе города ${city} из приемки удалятся выбранные дома. Продолжить?`;
  }

  return 'Из приемки удалятся выбранные дома. Продолжить?';
}
